import {View} from "@lernetz/ts-lib";
import template from "./slider.component.html";

export class SliderView extends View {
    sliderPosition = 0;
    controlToggleClass = 'md:flex';

    constructor() {
        super({template, data: new SliderController()})
    }
    init() {
        const controlLeft = this.node.querySelector( "[view='ControlLeft']");
        controlLeft.classList.add('hidden');
    }

    goLeft() {
        this.sliderPosition -= 200
        if (this.isSliderStart()) {
            this.sliderPosition = 0
        }
        this.applyTranslate()
    }

    goRight() {
        this.sliderPosition += 200;
        if (this.isSliderEnd()) {
            // Math.max ensures not a negative sliderposition
            this.sliderPosition = Math.max(this.maxPosition(), 0)
        }
        this.applyTranslate()
    }

    private isSliderStart() {
        return this.sliderPosition <= 0
    }

    private isSliderEnd() {
        return this.sliderPosition >= this.maxPosition()
    }

    private maxPosition() {
        const innerWidth = this.getInnerWidth()
        const containerPadding = parseFloat(window.getComputedStyle(this.node, null).getPropertyValue('padding-left'))
            + parseFloat(window.getComputedStyle(this.node, null).getPropertyValue('padding-right'))
        const containerWidth = this.node.clientWidth - containerPadding
        return innerWidth - containerWidth
    }

    private getInnerWidth() {
        return this.node.querySelector("[view='MainContent']").clientWidth;
    }

    private applyTranslate() {
        const slidingElement = this.node.querySelector( "[view='MainContent']") as HTMLElement;
        slidingElement.style.transform = `translateX(-${this.sliderPosition}px)`
        this.showControls()
    }

    private showControls() {
        const controlRight = this.node.querySelector( "[view='ControlRight']") as HTMLElement
        if (this.isSliderEnd()) {
            controlRight.classList.remove(this.controlToggleClass)
        } else {
            controlRight.classList.add(this.controlToggleClass)
        }

        const controlLeft = this.node.querySelector( "[view='ControlLeft']") as HTMLElement
        if (this.isSliderStart()) {
            controlLeft.classList.remove(this.controlToggleClass)
        } else {
            controlLeft.classList.add(this.controlToggleClass)
        }
    }

}

class SliderController {
}
